import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fetchAuthSession } from "@/lib/fetchAuthSession";

export default function LoginPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    void fetchAuthSession().then((r) => {
      if (r.ok) navigate("/", { replace: true });
    });
  }, [navigate]);

  const error = params.get("error");

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-6">
      <a href="#main-content" className="sr-only">
        Skip to content
      </a>

      <div className="flex max-w-md flex-col items-center text-center">
        <h1 className="serif text-ink mb-1 text-6xl font-light tracking-tight lowercase italic">
          sherlock
        </h1>
        <p className="mb-12 text-[10px] font-medium tracking-[0.35em] text-zinc-400 uppercase">
          by AKQA
        </p>

        <p className="mb-8 text-sm text-zinc-600">
          Sign in with your @akqa.com Google account.
        </p>

        {error && (
          <p
            role="alert"
            className="mb-6 max-w-sm rounded-lg border border-rose-100 bg-rose-50 px-4 py-3 text-sm text-rose-800"
          >
            {error}
          </p>
        )}

        <a
          href="/api/auth/login"
          className="inline-flex w-full max-w-sm items-center justify-center gap-3 bg-black px-8 py-4 text-sm font-medium tracking-wide text-white transition-opacity hover:opacity-90 focus-visible:ring-2 focus-visible:ring-zinc-400 focus-visible:outline-none"
        >
          <svg className="h-5 w-5 shrink-0" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="currentColor"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="currentColor"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="currentColor"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="currentColor"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
          Continue with Google
        </a>
      </div>

      <p className="serif absolute bottom-10 text-lg font-light tracking-tight text-zinc-400">
        AKQA
      </p>

      <main id="main-content" tabIndex={-1} className="sr-only">
        Sign-in screen
      </main>
    </div>
  );
}
